module.exports = __webpack_public_path__ + "img/wellwellwell-logo.7c01ae4b.png";